import { Link } from "react-router-dom";
import { MapPin, Phone, Clock } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#060f1f] border-t border-white/5 mt-32">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
        <div>
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 border border-[var(--gold)] flex items-center justify-center font-serif text-[var(--gold)] text-xl rotate-45">
              <span className="-rotate-45">A</span>
            </div>
            <div>
              <div className="font-serif text-xl text-white">Affari Oro</div>
              <div className="text-[0.6rem] uppercase tracking-[0.3em] text-[var(--gold-soft)]">Modena</div>
            </div>
          </div>
          <p className="text-sm text-[var(--text-secondary)] leading-relaxed">
            Il vostro compro oro di fiducia a Modena. Valutazioni gratuite, quotazioni trasparenti, pagamento immediato.
          </p>
        </div>

        <div>
          <h4 className="font-serif text-lg text-white mb-5 tracking-wide">Navigazione</h4>
          <ul className="space-y-3 text-sm">
            {[
              ["/", "Home"],
              ["/quotazioni", "Quotazioni Live"],
              ["/servizi", "Servizi"],
              ["/chi-siamo", "Chi Siamo"],
              ["/recensioni", "Recensioni"],
              ["/faq", "FAQ"],
              ["/contatti", "Contatti"],
            ].map(([to, l]) => (
              <li key={to}>
                <Link to={to} className="text-white/60 hover:text-[var(--gold)] transition-colors">
                  {l}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-serif text-lg text-white mb-5 tracking-wide">Contatti</h4>
          <ul className="space-y-4 text-sm text-white/70">
            <li className="flex gap-3"><MapPin size={16} className="text-[var(--gold)] shrink-0 mt-0.5" /><span>Via Fratelli Rosselli 265<br/>41125 Modena (MO)</span></li>
            <li className="flex gap-3"><Phone size={16} className="text-[var(--gold)] shrink-0 mt-0.5" /><a href="tel:+393389472101" className="hover:text-[var(--gold)]">+39 338 947 2101</a></li>
            <li className="flex gap-3"><Clock size={16} className="text-[var(--gold)] shrink-0 mt-0.5" /><span>Lun-Sab 09:00-12:30<br/>15:30-19:00</span></li>
          </ul>
        </div>

        <div>
          <h4 className="font-serif text-lg text-white mb-5 tracking-wide">Legale</h4>
          <ul className="space-y-3 text-sm">
            <li><Link to="/privacy" className="text-white/60 hover:text-[var(--gold)]">Privacy Policy</Link></li>
            <li><Link to="/cookie" className="text-white/60 hover:text-[var(--gold)]">Cookie Policy</Link></li>
            <li><Link to="/admin/login" className="text-white/40 hover:text-[var(--gold)] text-xs uppercase tracking-widest">Area Riservata</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row justify-between items-center gap-3">
          <p className="text-xs text-white/40">© {new Date().getFullYear()} Affari Oro di Berton Pasqualina — P.IVA 03468360361 — Via Fratelli Rosselli 265, Modena — Tutti i diritti riservati.</p>
          <p className="text-xs text-white/40 font-serif italic">Trustworthy. Transparent. Timeless.</p>
        </div>
      </div>
    </footer>
  );
}
